<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
    <form *ngIf="form" class="user-form mt-5" [formGroup]="form">
      <app-row>
        <app-col cols="12" class="mb-5">
          <mat-checkbox
            formControlName="allowToLogin"
            color="primary"
            (change)="onAllowToLoginChanges($event)"
            >
            {{ "Inputs.AllowToLogin" | translate}}
          </mat-checkbox>
        </app-col>

        <app-col sm="4">
          <mat-label class="asterisk-after">{{ "Inputs.FirstName" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput type="text" [placeholder]="'Placeholder.EnterFirstName' | translate" formControlName="firstName" />
            <mat-error
              *ngIf="
                    form.invalid &&
                    form.get('firstName').touched &&
                    form.get('firstName').hasError('required')
                  "
            >
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>

            <mat-error
              *ngIf="
                    form.invalid &&
                    form.get('firstName').touched &&
                    form.get('firstName').hasError('maxlength')
                  "
            >
              {{ "ErrorMessages.InValidMaxLength20" | translate }}
            </mat-error>

            <mat-error
              *ngIf="
                          form.invalid &&
                          form.get('firstName').touched &&
                         form.get('firstName').hasError('whitespace')"
            >
              {{ "ErrorMessages.InValidData" | translate }}
            </mat-error>
          </mat-form-field>
        </app-col>

        <app-col sm="4">
          <mat-label class="asterisk-after">{{ "Inputs.LastName" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput type="text" [placeholder]="'Placeholder.EnterLastName' | translate" formControlName="lastName" />
            <mat-error
              *ngIf="
                form.invalid &&
                form.get('lastName').touched &&
                form.get('lastName').hasError('required')
              "
            >
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>

            <mat-error
              *ngIf="
                form.invalid &&
                form.get('lastName').touched &&
                form.get('lastName').hasError('maxlength')
              "
            >
              {{ "ErrorMessages.InValidMaxLength20" | translate }}
            </mat-error>

            <mat-error
              *ngIf="
                      form.invalid &&
                      form.get('lastName').touched &&
                      form.get('lastName').hasError('whitespace')
                    "
            >
              {{ "ErrorMessages.InValidData" | translate }}
            </mat-error>
          </mat-form-field>
        </app-col>

        <app-col sm="4" *ngIf="!isProfile">
          <mat-label class="asterisk-after">{{ "Inputs.MobileNumber" | translate }}</mat-label>
          <app-row class="mb-4 gx-sm">
            <app-col cols="5">
              <mat-form-field class="w-100" appearance="outline">
                <mat-select #countrySelect="matSelect" formControlName="countryCode">
                  <mat-select-trigger>
                    <ng-container *ngFor="let c of countries">
                      <span class="d-flex align-items-center" *ngIf="c.phoneKey === countrySelect.value">
                        <span class="fi fi-{{ c.isoCode | lowercase }} mx-2"></span>
                        {{ c.phoneKey }}
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                  <mat-option *ngFor="let country of countries" [value]="country?.phoneKey">
                    <span class="d-flex align-items-center">
                      <span class="fi fi-{{ country?.isoCode | lowercase }} mx-2"></span>
                      {{ country?.phoneKey }}
                    </span>
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                          form.invalid &&
                          form.get('countryCode').touched &&
                          form.get('countryCode').hasError('required')
                        "
                >
                  {{ "ErrorMessages.Required" | translate }}
                </mat-error>
              </mat-form-field>
            </app-col>
            <app-col cols="7">
              <mat-form-field class="w-100" appearance="outline">
                <input matInput type="text" [placeholder]="'Placeholder.MobileNumber' | translate" formControlName="mobileNumber" />
                <mat-error *ngIf="form.invalid && form.get('mobileNumber').touched && form.get('mobileNumber').hasError('required')">
                  {{ "ErrorMessages.Required" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="
                            form.invalid &&
                            form.get('mobileNumber').touched &&
                            (form.get('mobileNumber').hasError('whitespace') ||
                            form.get('mobileNumber').hasError('invalidPhoneNumber'))"
                >
                  {{ "ErrorMessages.InvalidPhone" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="
                        form.invalid &&
                        form.get('mobileNumber').touched &&
                        (form.get('mobileNumber').hasError('invalidPhoneNumberLength'))"
                >
                  {{ "ErrorMessages.InValidMobileLength" | translate: {length: MobileLengthPerCode[form.get('countryCode').value]} }}
                </mat-error>
                <mat-error
                  *ngIf="
                        form.invalid &&
                        form.get('mobileNumber').touched &&
                        (form.get('mobileNumber').hasError('invalidPhoneNumberType'))"
                >
                  {{ "ErrorMessages.invalidPhoneNumberType" | translate }}
                </mat-error>
              </mat-form-field>
            </app-col>
          </app-row>
        </app-col>

        <app-col sm="4" *ngIf="!user?.isEmailVerified || isProfile">
          <mat-label [ngClass]="{'asterisk-after': form.get('allowToLogin').value }">{{ "Inputs.Email" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput type="text" [placeholder]="'Placeholder.Email' | translate" formControlName="email" />
            <mat-error
              *ngIf="
                form.invalid &&
                form.get('email').touched &&
                form.get('email').hasError('required')
              "
            >
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                form.invalid &&
                form.get('email').touched &&
                form.get('email').hasError('invalidEmail')
              "
            >
              {{ "ErrorMessages.InvalidEmail" | translate }}
            </mat-error>
          </mat-form-field>
        </app-col>

        <app-col sm="4" *ngIf="!isProfile">
          <app-dropdown
            formControlName="country"
            class="select-options"
            [title]="'Inputs.Country' | translate"
            [placeholder]="'Placeholder.SelectCountry' | translate"
            [list]="countries"
          ></app-dropdown>
        </app-col>

        <app-col sm="4" *ngIf="!router.url.includes('carrier') && !isProfile">
          <mat-label class="asterisk-after">{{ "Inputs.Privilege" | translate }}</mat-label>
          <mat-form-field class="w-100" appearance="outline">
            <mat-select formControlName="roles" multiple [placeholder]="
                        'Placeholder.SelectPrivilege' | translate
                      "
            >
              <mat-checkbox
                app-click-stop-propagation
                class="mat-option"
                [disableRipple]="true"
                [indeterminate]="isIndeterminate()"
                [checked]="isChecked()"
                (change)="toggleSelection($event)"
              >
                {{ "Options.SELECT_ALL" | translate }}
              </mat-checkbox>

              <mat-option *ngFor="let role of roles" [value]="role.id">
                {{ 'Enum.Roles.' + role.name | translate }}

                <mat-divider></mat-divider>
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="
                      form.invalid &&
                      form.get('roles').touched &&
                      form.get('roles').hasError('required')
                    "
            >
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>

          </mat-form-field>
        </app-col>

        <app-col sm="4" *ngIf=" action === 'update' && !isProfile ">
          <mat-label>{{ "Inputs.Status" | translate }}</mat-label>
          <mat-form-field class="w-100" appearance="outline">
            <mat-select formControlName="status" [placeholder]="'Placeholder.SelectStatus' | translate">
              <mat-option *ngFor="let status of userStatus | enumToArray" [value]="status.value">
                {{ "Enum.UserStatus." + status.key | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-col>

        
        <app-col sm="4" *grantAccess="rolesConstants.CUSTOMER_ADD_EDIT_USER; onlyIf: userType === UserType.CUSTOMER">
          <mat-label>{{ "Inputs.ShippingType" | translate }}</mat-label>
          <mat-form-field class="w-100" appearance="outline">
            <mat-select formControlName="shippingType" [placeholder]="'Placeholder.SelectType' | translate">
              <mat-option *ngFor="let type of ShippingType | enumToArray" [value]="type.value">
                {{ "Enum.ShippingType." + type.value | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-col>
        
      </app-row>
      <div class="user-form__actions mt-8">
        <app-row>
          <app-col sm="2">
            <button mat-raised-button class="btn-secondary w-100" (click)="close.emit();">
              {{ "Buttons.Cancel" | translate }}
            </button>
          </app-col>

          <app-col sm="2" class="ml-sm-auto" *ngIf="action === 'add'">
            <button [disabled]="form.invalid" mat-raised-button color="primary"
             class="w-100" (click)="onAddUser()">
              {{ "Buttons.AddUser" | translate }}
            </button>
          </app-col>

          <app-col sm="2" class="ml-sm-auto" *ngIf="action === 'update'">
            <button [disabled]="form.invalid" mat-raised-button color="primary" 
            class="w-100" (click)="onUpdateUser()">
              {{ "Buttons.Update" | translate }}
            </button>
          </app-col>
        </app-row>
      </div>
    </form>
</app-state-section>
